@if(showResultList === true && showObject.length != 0){
<div
    class="closing"
    (click)="toggleResultView()"
    *ngIf="showResultList === true"
></div>
<div class="wrapper">
    <div *ngFor="let re of showObject" class="w100 wrapperlist">
        @if(re.results.length > 0){
        <div class="name w100">{{ re.name }}</div>

        <div
            class="col w100"
            *ngFor="let item of re.results; let index = index"
        >
            <span class="stepname" *ngIf="re.streamId === 'J1S-8At2nL'"
                >STEP - {{ index + 1 }} {{ item.file ? item.name : "" }}</span
            >
            <div class="row align-center w100 space-between resultitem">
                <div
                    class="row align-center gap-8 pointer"
                    (click)="downloadFile(item, re.streamId)"
                >
                    <rr-icon
                        name="file"
                        color="nutral"
                        class="roundicon"
                    ></rr-icon>
                    @if(item.file){
                    <div class="col" *ngIf="item.file">
                        <span class="filename">{{ item.file.fileName }}</span>
                        <span class="filesize"
                            >{{ item.file.fileSize | calcFileSizeInKb }} -
                            {{ item.file.dateCreated | localTimeDate }}</span
                        >
                    </div>
                    }@else if(item.stepId === 'landingPage') {
                    <div class="col">
                        <span class="filename">{{ item.name }}</span>
                        <span class="filesize">open Preview</span>
                    </div>
                    }@else if(item.stepId === 'k9G9Fv8w6') {
                    <div class="col">
                        <span class="filename">{{ item.name }}</span>
                        <span class="filesize">open Board</span>
                    </div>
                    }@else {
                    <div class="col">
                        <span class="filename">{{ item.name }}</span>
                        <span class="filesize"
                            >Click to generate & download file</span
                        >
                    </div>
                    }
                </div>
                <rr-icon
                    name="trash"
                    color="nutral"
                    class="pointer delbtn"
                    *ngIf="item.file && item.file.userId == userId"
                    (click)="deleteFile(item)"
                ></rr-icon>
            </div>
        </div>
        }
    </div>
</div>
}

<rr-btn
    type="Secondary"
    size="Small"
    (click)="toggleResultView()"
    [counter]="counter"
    [disabled]="showObject!.length > 0 ? false : true"
>
    Show Results
</rr-btn>
<rr-spinner *ngIf="loading === true"></rr-spinner>
